import type { Story } from '@/mocks/stories';
import StatusBadge from './StatusBadge';

export default function StoryCard({ story }: { story: Story }) {
  return (
    <article className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300">
      <div className="relative h-44 w-full flex-shrink-0 overflow-hidden bg-background-200">
        <img
          src={story.image}
          alt={`${story.title}相关配图`}
          title={`${story.title} - 后续进展追踪`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 inline-flex items-center whitespace-nowrap rounded-md bg-foreground-950/75 px-2.5 py-1 text-xs font-medium text-background-50">
          {story.category}
        </span>
        <span className="absolute right-3 top-3 rounded-md bg-background-50/95 px-1.5 py-1">
          <StatusBadge status={story.status} />
        </span>
      </div>

      <div className="flex flex-1 flex-col p-4 md:p-5">
        <h3 className="font-heading text-base font-bold leading-snug text-foreground-950 md:text-lg">
          <a href="#timeline" className="transition-colors hover:text-primary-600">
            {story.title}
          </a>
        </h3>
        <p className="mt-2 line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-600">{story.summary}</p>

        <div className="mt-3 flex flex-wrap gap-1.5">
          {story.tags.map((tag) => (
            <span
              key={tag}
              className="whitespace-nowrap rounded-full bg-secondary-100 px-2 py-0.5 text-xs text-secondary-800"
            >
              #{tag}
            </span>
          ))}
        </div>

        <div className="mt-4 flex items-center justify-between border-t border-background-100 pt-3 text-xs text-foreground-500">
          <span className="flex items-center gap-1.5 whitespace-nowrap">
            <i className="ri-fire-line text-primary-500" />
            热度 {story.heat}
          </span>
          <span className="whitespace-nowrap">{story.updatedAt}</span>
        </div>
        <p className="mt-2 text-xs text-foreground-400">{story.note}</p>
      </div>
    </article>
  );
}